import React from 'react'
import { graphql } from '@apollo/client/react/hoc';
import { gql } from "@apollo/client";

const byCategory = (policies) => {
  const groups = [];
  for (let i = 0; i < policies.length; i++) {
    var p = policies[i];
    const category = (p.category && p.category.length) ? p.category[0] : { name: 'Core', order: 0 };
      const group = groups.find(g => g.name === category.name);
      if (group) {
        group.policies.push(p);
      } else {
        groups.push({
          name: category.name,
          order: category.order,
          policies: [p]
        })
      }
    }
  return groups.sort((a, b) => (a.order || Number.MAX_SAFE_INTEGER) - (b.order || Number.MAX_SAFE_INTEGER));
}

class PoliciesDataContainer extends React.Component {
  render() {
    const { loading, exclude, include, policies, error, group } = this.props;

    if (loading) return null;
    if (error) return <p>An unexpected error has occured</p>;

    let arr = [];

    if (include) {
      arr = policies.filter(item => {
        if (!item.category) return false;
        if (item.category.map(c => c.name).indexOf(include) > -1) {
          return true
        }
        return false;
      })
      
    } else if (exclude) {
      arr = policies.filter(item => {
        if (!item.category) return false;
        if (item.category.map(c => c.name).indexOf(exclude) > -1) {
          return false
        }
        return true;
      })
    } else {
      arr = [...policies];
    }

    arr.sort((a, b) => (a.order || Number.MAX_SAFE_INTEGER) - (b.order || Number.MAX_SAFE_INTEGER));
    if (group) {
      arr = byCategory(arr);
    }

    return this.props.render(arr, group)
  }
}

PoliciesDataContainer.defaultProps = {
  group: false,
  include: null,
  exclude: null
}

const POLICIES_QUERY = gql`
  query getTemplate {
    policies {
      id
      slug
      title {
        rendered
      }
      excerpt {
        rendered
      }
      featured_media {
        id
        source_url
        title {
          rendered
        }
      }
      download
      order
      category {
        id
        name
        order
      }
    }
  }
`;

const withTemplate = graphql(POLICIES_QUERY, {
  props: ({ data, post }) => ({ ...data }),
});

export default withTemplate(PoliciesDataContainer);
